import React from "react";
import FacilityFormPage from "../components/facilities/FacilityFormPage";

const FacilityCreate = () => <FacilityFormPage mode="create" />;

export default FacilityCreate;
